module.exports = __webpack_public_path__ + "img/headportrait_3_icon.a24409b0.png";